import {
  Component,
} from '@angular/core';
import { RouteConstants } from 'src/app/models/common/enums/RouteConstants.enum';
import { UserType } from 'src/app/models/directory/enums/UserType.enum';
@Component({
  selector: 'app-update-coco-user',
  templateUrl: './update-coco-user.component.html',
})
export class UpdateCocoUserComponent {
  userType: UserType = UserType.Coco;
  displayedColumns: string[] = ['displayName', 'mail', 'employeeId', 'department'];
  route: string = RouteConstants.Coco;
}
